import Blue from "~/core";
import Swiper from "swiper";
import { Navigation, Pagination } from 'swiper/modules';

Swiper.use([Navigation, Pagination]);

new Blue({
	name: 'Card Slider',
	selector: ".cardSlider--default",
	setup(cardSlider) {
		let swiper = new Swiper(cardSlider.querySelector('.swiper-container'), {
			watchOverflow: true,
			breakpoints: {
				320: {
					slidesPerView: 1,
					spaceBetween: 20,
				},
				576: {
					slidesPerView: 2,
					spaceBetween: 30
				},
				992: {
					slidesPerView: 3,
					spaceBetween: 40
				},
				1100: {
					slidesPerView: 4,
					spaceBetween: 50
				}
			},
			navigation: {
				nextEl: cardSlider.querySelector('.swiper-button-next'),
				prevEl: cardSlider.querySelector('.swiper-button-prev'),
			}
		});
	}
});

new Blue({
	name: 'Card Slider',
	selector: ".cardSlider--rates",
	setup(cardSlider) {
		const container = cardSlider.querySelector('.cardSlider__container');
		const wrapper = cardSlider.querySelector('.cardSlider__wrapper');
		const slides = [...cardSlider.querySelectorAll('.cardSlider__slide')];
		const prevButton = this.$createElement({
			attributes: {
				class: 'swiper-button-prev'
			}
		});
		const nextButton = this.$createElement({
			attributes: {
				class: 'swiper-button-next'
			}
		});

		const intializeSwiper = () => {
			cardSlider.insertAdjacentElement('beforeend', prevButton);
			cardSlider.insertAdjacentElement('beforeend', nextButton);
			container.classList.add('swiper-container');
			wrapper.classList.add('swiper-wrapper');
			slides.forEach(slide => {
				slide.classList.add('swiper-slide');
			});

			let swiper = new Swiper(container, {
				watchOverflow: true,
				pagination: {
					el: cardSlider.querySelector('.swiper-pagination'),
					type: 'bullets',
				},
				breakpoints: {
					768: {
						slidesPerView: 2,
						spaceBetween: 10
					},
					992: {
						slidesPerView: 3,
						spaceBetween: 20
					},
					1100: {
						slidesPerView: 4,
						spaceBetween: 30
					}
				},
				navigation: {
					nextEl: cardSlider.querySelector('.swiper-button-next'),
					prevEl: cardSlider.querySelector('.swiper-button-prev'),
				}
			});
		}

		const destroySwiper = () => {
			container.classList.remove('swiper-container');
			wrapper.classList.remove('swiper-wrapper');
			slides.forEach(slide => {
				slide.classList.remove('swiper-slide');
				slide.removeAttribute('style');
				if(slide.classList.contains('swiper-slide-active')) {
					slide.classList.remove('swiper-slide-active');
				}
			});
		}
		
		if(this.$screen.md.matches) {
			intializeSwiper();
		}

		this.$addEvents(window, 'resize', () => {
			if(this.$screen.md.matches) {
				intializeSwiper();
			} else {
				destroySwiper();
			}
		})
	}
});